import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faHammer, faDraftingCompass, faHardHat, faRulerCombined, faGlobe } from '@fortawesome/free-solid-svg-icons';

const Homebody1 = () => {
  const services = [
    { name: "Construction", icon: faHammer, description: "We build with precision and quality to ensure lasting infrastructure." },
    { name: "Architecture", icon: faDraftingCompass, description: "Innovative designs that shape the future of urban landscapes." },
    { name: "Engineering", icon: faHardHat, description: "Cutting-edge engineering solutions for complex challenges." },
    { name: "Project Management", icon: faRulerCombined, description: "Efficient and strategic project execution from start to finish." },
    { name: "Real Estate", icon: faBuilding, description: "Premium real estate solutions for commercial and residential spaces." },
    { name: "Global Outreach", icon: faGlobe, description: "Expanding our expertise to global markets with excellence." }
  ];

  return (
    <div className="relative bg-gradient-to-r from-[#6EE7B7] to-[rgb(41, 49, 63)] text-gray-900 py-10">
      <div className="absolute inset-0 bg-black opacity-20"></div>
      <div className="relative max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 z-10">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            viewport={{ once: false, amount: 0.3 }}
            className="bg-white shadow-lg rounded-xl overflow-hidden hover:shadow-xl transform transition-all"
          >
            <div className="p-6 text-center">
              <FontAwesomeIcon icon={service.icon} size="3x" className="text-[rgb(41, 49, 63)] mb-4" />
              <h3 className="text-2xl font-semibold text-[rgb(41, 49, 63)] mb-4">{service.name}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Homebody1;
